import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  to: {
    type: String,
    default: undefined,
  },
  isDelete: Boolean,
  isTitle: Boolean,
  disable: Boolean,
},
  emits: ['click'],
  setup(__props, { emit }) {





function triggerClick (e) {
  emit('click', e)
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    clickable: !__props.disable && !__props.isTitle,
    disable: __props.disable,
    to: __props.to,
    class: _normalizeClass({
      'is-delete': __props.isDelete,
      'font-weight-bold': __props.isTitle
    }),
    onClick: triggerClick
  }, {
    default: _withCtx(() => [
      (__props.icon && __props.icon.length)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 0,
            avatar: "",
            class: "min-w-8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                class: "inherit-text",
                name: __props.icon
              }, null, 8, ["name"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          (__props.text)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(__props.text), 1)
              ], 64))
            : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["clickable", "disable", "to", "class"])), [
    [_directive_close_popup]
  ])
}
}

})